export const GLOBAL_STATE = 'Semester'

export const SEMESTER_ALL = 'SEMESTER_ALL' as const
